import React from 'react';
import SEOHead from '../components/SEO/SEOHead';
import WhereIShoot from '../components/Home/WhereIShoot';
import { useWebsiteContent } from '../hooks/useWebsiteContent';

const AboutPage: React.FC = () => {
  const websiteContent = useWebsiteContent();

  const description = websiteContent.aboutDescription || websiteContent.heroDescription || 'Learn about Carmen Lorraine, a professional photographer based in Cape Town, South Africa, specializing in portraits, weddings, and events.';

  return (
    <div className="about-page">
      <SEOHead
        title="About Carmen Lorraine - Professional Photographer"
        description={description}
        keywords={['about photographer', 'Cape Town photographer', 'professional photographer', 'portrait photographer', 'wedding photographer']}
        type="profile"
      />
      <main className="page-content">
        <section className="about-section">
          <div className="about-content">
            <div className="about-text">
              <h1 className="elegant-heading">About Carmen Lorraine</h1>
              <p className="hero-description">{websiteContent.heroDescription}</p>
              <p className="about-description">{websiteContent.aboutDescription}</p>
              <WhereIShoot />
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default AboutPage;

